import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const SearchWidget2 = () => {
  const [query, setQuery] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    // Only navigate if there is a query.
    if (query.trim()) {
      navigate(`/blogs?query=${encodeURIComponent(query)}`);
    }
  };

  return (
    <div className=' mt-40 container col-lg-8 search-widget2'>
    <div className="widget single-post-item ">
      <h2 className="widget__title">Search</h2>
      <form className="widget__search" onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Search..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
        <button type="submit">
          <i className="far fa-search"></i>
        </button>
      </form>
    </div>
    </div>
  );
};

export default SearchWidget2;
